<template>
    <el-row :gutter="30"  class="mw-100 manage-coveragePhoto" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-form 
                    class="text-center font-24" 
                    ref="addCoveragePhotoRef"
                    :model="currentCoveragePhotoData"
                    :rules="currentCoveragePhotoDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageCoveragePhoto('addCoveragePhotoRef',index)" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="24" :xs="24">
                            <el-row :gutter="30">
                                <el-col :lg="12" :xs="24">
                                    <el-form-item  label="coveragePhoto image" prop="imageBase64">
                                        
                                        <el-image 
                                            style="width: 150px; height: 150px;margin-right:20px" 
                                            :src="isAddCoveragePhoto ? currentCoveragePhotoData.imageURL :  $getImage(currentCoveragePhotoData.imageURL) || ''" 
                                            fit="cover"
                                            :zoom-rate="1.2"
                                            :preview-src-list="[isAddCoveragePhoto ? currentCoveragePhotoData.imageURL : $getImage(currentCoveragePhotoData.imageURL)]"
                                            :preview-teleported="true"
                                        >
                                            <template #error>
                                                <div class="image-slot">
                                                    <font-awesome-icon :icon="['fas', 'image']" />
                                                </div>
                                            </template>
                                        </el-image>
                                        <el-upload
                                            ref="imageBase64"
                                            action="#"
                                            :auto-upload="false"
                                            :on-change="onUploadImage"
                                            :disabled="fileUploaded"
                                            :on-remove="handleRemoveImage"
                                            accept="image/png, image/jpeg,image/gif"
                                            class="font-24 d-flex align-center flex-1"
                                        >
                                            <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddCoveragePhoto:true,
            currentCoveragePhoto:[],
            fileUploaded:false,
            currentCoveragePhotoData:{},
            currentCoveragePhotoDataRules:{
                imageBase64:{
                    required:true,
                    trigger:'blur',
                    message:'required field'
                },
            }
        };
    },
    computed:{
        cachedCoveragePhoto(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.services?.coveragePhotos?.currentCoveragePhoto || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedCoveragePhoto.languageID) {
            this.isAddCoveragePhoto = false;
            this.currentCoveragePhotoData = JSON.parse(JSON.stringify(this.cachedCoveragePhoto));
            this.currentCoveragePhotoData = this.converUpdatedObj(this.currentCoveragePhotoData);
           
        }else{
            this.$router.push({
                name:'photos-list',
            })
            this.isAddCoveragePhoto = true;
            this.currentCoveragePhotoData = this.initState()
            this.currentCoveragePhotoDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
        }
    },
    
    methods:{
        initState(){
            return {
             
                translates:this.$setTranslateKeys({
                    'description':'',
                    'title':'',
                }),
                
            }
        },
        
        async manageCoveragePhoto(formName){
            const element = this.$refs[formName];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`the image should not be empty `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    if (data){
                        this.manageCoveragePhotoAfterValidate()
                    }
                })  
           
            
            
            
            
            
        },
        async manageCoveragePhotoAfterValidate(){
            let clonedData = JSON.parse(JSON.stringify(this.currentCoveragePhotoData));
            delete clonedData.imageURL;
            
            
            const response = await this.$store.dispatch(this.isAddCoveragePhoto ? 'addCoveragePhoto':'editCoveragePhoto',clonedData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllCoveragePhotos');
                this.$router.push({
                    name:'photos-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentCoveragePhotoData.imageBase64 = evt.target.result;
                }); 
                this.currentCoveragePhotoData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        }, 
        handleRemoveImage(){
            this.currentCoveragePhotoData.imageURL = this.isAddCoveragePhoto ? '' : this.cachedCoveragePhoto.imageURL
        },   
        handlePictureCardPreview(file){
            this.dialogVisible = true;
            this.dialogImageUrl = file.url;

        },
        handleRemove(file){
            let imageIndexFromSubITems;
            if(file.name  == 'oldItem') {
                imageIndexFromSubITems = this.currentCoveragePhotoData.subItems.findIndex(img => img.id == file.uid);
                this.currentCoveragePhotoData.subItems[imageIndexFromSubITems].active = false;
                this.currentCoveragePhotoData.subItems[imageIndexFromSubITems].uid = file.uid;
            }else{
                imageIndexFromSubITems = this.currentCoveragePhotoData.subItems.findIndex(img => img.uid == file.uid);
                this.currentCoveragePhotoData.subItems.splice(imageIndexFromSubITems,1);
            }
        },
        onUploadBrand(file){
            const FR = new FileReader();
            let module = this;
            FR.addEventListener("load", function(evt) {
                module.currentCoveragePhotoData.subItems.push({
                    imageBase64:evt.target.result,
                    seq:0,
                    uid:file.uid,
                    id:-1,
                });
            }); 
            // this.currentCoveragePhotoData.imageURL =  URL.createObjectURL(file.raw);

            FR.readAsDataURL(file.raw);
        },
        converUpdatedObj(oldObj){
            // Copy the object
            let newObj = Object.assign({}, oldObj);
            delete newObj.value;
            delete newObj.image2URL;
            return newObj
            
        }
    }
}
</script>
<style lang="scss">
    .manage-coveragePhoto {
        .ck-editor {
            width:100%;
        }
    }
</style>